// Mobile
export const SMALL_MOBILE_MAX_WIDTH = 320;
export const LARGE_MOBILE_MIN_WIDTH = 321;
export const LARGE_MOBILE_MAX_WIDTH = 592;
export const MOBILE_MAX_WIDTH = LARGE_MOBILE_MAX_WIDTH;

// Tablets
export const SMALL_TABLET_MIN_WIDTH = 593;
export const SMALL_TABLET_MAX_WIDTH = 767;
export const LARGE_TABLET_MIN_WIDTH = 768;
export const LARGE_TABLET_MAX_WIDTH = 1024;
export const TABLET_MIN_WIDTH = SMALL_TABLET_MIN_WIDTH;
export const TABLET_MAX_WIDTH = LARGE_TABLET_MAX_WIDTH;

// Desktop
export const SMALL_DESKTOP_MIN_WIDTH = 1025;
export const SMALL_DESKTOP_MAX_WIDTH = 1199;

// Below numbers generally match src/client/less/common/sizes.less
export const LARGE_DESKTOP_MIN_WIDTH = 1200;
export const LARGE_DESKTOP_MAX_WIDTH = 1399;
export const X_LARGE_DESKTOP_MIN_WIDTH = 1400;
export const X_LARGE_DESKTOP_MAX_WIDTH = 1499;
export const XX_LARGE_DESKTOP_MIN_WIDTH = 1500;
export const XX_LARGE_DESKTOP_MAX_WIDTH = 1920;

// > 1080p, such as 4k
export const XXX_LARGE_DESKTOP_MIN_WIDTH = 1921;

export const SLACK_EMBED_WIDTH = 360;

export const COMMENTS_BREAKPOINT = 520;

export const DESKTOP_MIN_WIDTH = SMALL_DESKTOP_MIN_WIDTH;
